// extracted by mini-css-extract-plugin
export default {"section":"ProductSection_section__J1g30","title":"ProductSection_title__E6c+o","dropdown":"ProductSection_dropdown__TlhHd"};